module.exports = __webpack_public_path__ + "img/40.4fcb81d9.jpeg";